
import {MessageDto} from '../interfaces/dto/message.dto';
import {CampaignMessageDto} from '../interfaces/dto/campaign-message.dto';

export function isCampaignMessageDto(item: MessageDto | CampaignMessageDto): item is CampaignMessageDto {
  return (item as CampaignMessageDto).resolvedAt !== undefined;
}
